<script>
import { createEngineer, updateEngineer } from '@/utils/engineer'
import { allUsers } from '@/utils/user'  

export default {

    inject: ['setLoading'],

    data() {
        return {
            id: null,
            engineers: [],
            engineer_id: '',
            errors: {}
        }
    },

    methods: {

        async open(row = null) {
            this.reset()
            await this.loadDropdown()

            if (row) {
                this.id = row.id
                this.engineer_id = row.user?.id
            }
        },

        async loadDropdown() {
            try {
                const res = await allUsers() 
                this.engineers = res?.data?.data || []
            } catch (e) {
                this.$swalToast(e.message, 'error')
            }
        },

        async save() {
            this.setLoading(true)

            try {
                const payload = {
                    user_id: this.engineer_id
                }

                let res

                if (this.id) {
                    res = await updateEngineer(this.id, payload)
                } else {
                    res = await createEngineer(payload)
                }

                this.$swalToast(res.data.message)
                this.$emit('updated')
                this.$closeModal('engineer_modal')

            } catch (error) {
                if (error.type === 'validation') {
                    this.errors = error.errors
                } else {
                    this.$swalToast(error.message, 'error')
                }
            } finally {
                this.setLoading(false)
            }
        },

        reset() {
            this.id = null
            this.engineer_id = ''
            this.errors = {}
        }
    }
}
</script>

<template>
    <div class="modal fade" id="engineer_modal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <div class="modal-header">
                    <h5>{{ id ? 'Edit' : 'Add' }} Engineer</h5>
                    <button class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <form @submit.prevent="save">
                    <div class="modal-body">
                        <div class="mb-3">
                            <label class="form-label">Select Engineer</label>

                            <!-- label -->
                            <vue-select
                                :options="engineers"
                                :get-option-label="row => row.name"
                                :reduce="row => row.id"
                                v-model="engineer_id"
                                placeholder="Select Engineer"
                            />

                            <div v-if="errors.user_id"
                                style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                                <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.user_id[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
                        <button class="btn btn-primary">Save</button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>